import { graphql } from "@/lib/gql/__generated__/gql";

export const OptionDelete_OptionListPage_Mutation = graphql(/* GraphQL */ `
	mutation OptionDelete_OptionListPage($hotelID: ID!, $optionID: ID!) {
		optionDelete(hotelID: $hotelID, optionID: $optionID) {
			userErrors
			message
		}
	}
`);
